/* eslint-disable quotes */
export default {
  dashboard: {
    title: "GEOSPATIAL ANIMAL HEALTH SURVEILLANCE DASHBOARD",
    zones: "Areas",
    registration: "Registrations",
    localisedRegistration: "Localised registrations",
    refresh: "Refresh",
    streetView: "Street View",
    satelliteView: "Satellite View",
    rechercherRegistrationRef: "Search for a registration with its reference",
    barChartTitle: "Number of species affected by disease type",
    lineChartTitle: "Evolution of the main animal diseases",
    mapTitle: 'Geographic location of reported epidemic outbreaks',
    pieChartTitle: "Distribution of sick animals by species",
    boxCardTitle: "Distribution of sick animals by breed",
    copyRight: "© 2025 Kella DOUZOUNE. All rights reserved.",
    sickAnimals: "Sick animals",
    selectSpecie: "Select a species",
    selectYear: "Select a year",
    years: 'Years',
    months: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
    },
  },
  general: {
    close: "Close",
    description: "Description",
    code: "Code",
    nom: "Name",
    libelle: "Label",
    title: "Title",
    type: "Type",
    search: "Search",
    add: "Add",
    export: "Export",
    id: "ID",
    date: "Date",
    author: "Author",
    status: "Status",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    keyword: "Keywords",
    role: "Role",
    permissions: "Permissions",
    menus: "Menus",
    rolesEtpermissions: "Roles and permissions",
    deleteWarningText: "Are you sure you want to delete?",
    deleteConfirmButtonText: "Yes delete",
    deleteCancelButtonText: "No leave",
    save: "Save",
    saving: "Saving ...",
    closingWarningText: "Are you sure you want to close?",
    notFound: "No item found",
    actives: "Actives",
    visible: "Visible",
    disponibles: "Available",
    M_actives: "Enabled",
    F_actives: "Enabled",
    M_desactives: "Deactivated",
    F_desactives: "Deactivated",
    M_supprimes: "Deleted",
    F_supprimes: "Deleted",
    corbeille: "Trash",
    restaurer: "Restore",
    suppressionDefinitive: "Definitive deletion",
    nonActives: "Not active",
    nonVisibles: "Not visible",
    F_actif: "Active",
    M_actif: "Active",
    deleteContinue: "Continue ?",
    suppressionAnnule: "Deletion canceled",
    filter: "Filter",
    init: "Reset",
    statusUpdated: "Status update successfully completed!",
    statusUpdateError: "Sorry, an error occurred while updating the status",
    ouiSupprimer: "Yes delete",
    irrversibleMessage: "This action is irreversible",
    SureQuestion: "Are you sure ?",
    periode: "Period",
    startDateplaceholder: "Start date",
    endDateplaceholder: "End date",
    DaterangeSeparator: "to",
    ImapeUploadFieldText: "Click to send",
    clotures: "Closed",
    allpermissions: "All permissions",
    admins: "Admins",
    donors: "Donors",
    recipients: "Recipients",
    others: "Others",
    processing: "Processing",
    success: "Success",
    error: "Error",
    disabled: "Disabled",
    enabled: "Enabled",
    details: "Details",
    yes: "Yes",
    no: "No",
    paredExchange: "Paired exchange",
    paired: "Paired",
    guest: "Guests",
    editors: "Editors",
    othersUsers: "Other users",
    users: "Users & Members",
    publish: "Publish",
    SaveDraft: "Save as a draft",
    envoiEncours: "Sending in progress...",
    envoyer: "Send",
    sendGeneralNotification: "Notify them all",
    invalidForm: "Please check the information entered",
    accountIsActive: "Your account is active!",
    accountIsActiveDetails:
      "Your account is active, please download the GéoSanté application available on AppStore and PlayStore to access your account",
    reference: "Reference",
    unknown: "Unknown",
    noData: "No data available",
    import: "Import",
  },
  route: {
    dashboard: "Home",
    introduction: "Introduction",
    documentation: "Documentation",
    guide: "Guide",
    permission: "Permission",
    pagePermission: "Permission page",
    rolePermission: "Role and Permission",
    icons: "Icons",
    components: "Components",
    componentIndex: "Introduction",
    errorPages: "Error Pages",
    page401: "401",
    page404: "404",
    errorLog: "Log",
    administration: "Administration",
    users: "Users",
    userProfile: "User profile",
    species: "Species",
    diseases: "Disease",
    provinces: "Provinces",
    breeds: "Breeds",
    registrations: "Registrations",
    departments: "Departments",
    municipalities: "Municipalities",
    villages: "Villages",
    reports: "Reports",
    subscriptions: "Members",
    articles: "Articles",
    tags: "Tags",
    categoriestags: "Categories and tags",
    editArticle: "Edit article",
    discussions: "Discussions",
    UserProfile: "Profile",
    comments: "Comments",
    locations: "Locations",
    animals: "Animals",
  },
  navbar: {
    logOut: "Logout",
    dashboard: "Home",
    github: "Github",
    size: "Globale size",
    profile: "Profile",
  },
  login: {
    title: "Sign in",
    logIn: "Loged in",
    username: "Username",
    password: "Password",
    email: "Email address",
    correctEmail: "Please enter the correct email",
    shortPassword: "Password cannot be less than 6 digits",
    emailOrUsername: "Email address or Username",
    emailOrUsernameRequired: "Please enter your email address or username",
  },
  passwordreset: {
    enterCode: "Entrez le code envoyé par mail",
    checkCode: "Vérifier",
    token: "Code",
    forgotPassword: "I forgot my password",
    resendcode: "Return the code",
    enterEmail: "Enter your e-mail adress",
    sendcode: "Send code",
    setYourPassword: "Set your new password",
    confirmPassword: "Confirm your password",
    password: "Enter your password",
    savepassword: "Save",
    ConfirmPasswordRequired: "Confirm your password",
    codeIsRequired: "Please enter the code",
    successEnd: "Your password has been changed!",
    successEndDetails:
      "You have successfully changed your password! you can now log in with your new password",
    codeIsValid: "Code valid! please enter your new password",
    codeSent: "A code has been sent to you by email, please check",
  },
  permission: {
    addRole: "New Role",
    editPermission: "Edit Permission",
    editPermissions: "Edit Permissions",
    roles: "Roles",
    switchRoles: "Activate roles",
    delete: "Delete",
    confirm: "Confirm",
    cancel: "Cancel",
    permissionsUpdated: "The permissions have been updated!",
    extraPermissions: "Additional permissions",
    addedPermissions: "Added permissions",
    noSelectionAdd: "No permissions added",
    manage: "Manage permissions",
    addPermissions: "Add permissions",
    tableName: "Table name",
    NameRequired: "Please enter name",
    iscreatedSuccessfully: "Permission added successfully",
    name: "Permission",
    suppressionEffectue: "Permission successfully deleted",
  },
  excel: {
    export: "Export",
    selectedExport: "Export selected items",
    placeholder: "Enter the file name please (default: list-excel)",
  },
  theme: {
    change: "Change the Theme",
    documentation: "Theme documentation",
    tips: "Tips: It is different from the theme choice on the navigation bar, it is two different skinning methods, each with different application scenarios.",
  },
  settings: {
    title: "Page style configuration",
    theme: "Theme color",
    tagsView: "Show tags",
    fixedHeader: "Fix the header",
    sidebarLogo: "Logo",
  },
  tagsView: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close others",
    closeAll: "CLose all",
  },
  user: {
    name: "Name",
    user: "User",
    role: "Role",
    password: "Password",
    c_password: "Confirm",
    nom: "Name",
    prenom: "First name",
    email: "Email address",
    username: "Username",
    code: "Code",
    EditPermissions: "Edit permissions",
    AddUser: "Add user",
    selectRole: "Select a role",
    PasswordsInconform: "Passwords do not match",
    RoleRequired: "Please select a role",
    NomRequired: "Enter the name",
    EmailRequired: "Enter the email address",
    EmailInvalide: "Enter a valid email address",
    PasswordRequired: "Enter the password",
    deleteWarn: "This will delete the user",
    deleteContinue: "Continue ?",
    cancel: "Cancel",
    suppressionEffectue: "Deletion completed successfully!",
    suppressionAnnule: "Deletion canceled",
    NewUser: "New user",
    iscreatedSuccessfully: " was successfully created",
    PermissionsUpdated: "Permissions updated successfully!",
    users: "Users",
    edit: "Edit user",
    PasswordMin6: "Must be at least 6 characters",
    isupdatedSuccessfully: "User updated successfully",
    changeCredentils: "Change credentials",
    nochangeCredentils: "Do not change the password",
    changeAvatar: "Upload",
    account: "Account",
    enterPassword: "Enter your password to continue",
    profileUpdated: "Your profile has been updated !",
    willAddPassword: "The user will add his own password",
    willAddPasswordMessage:
      "An email will be sent to the user on the email address provided with a link to set his password",
  },
  message: {
    message: "Message",
    messages: "Messages",
    subject: "Subject",
    description: "Description",
    subjectRequired: "Please enter the subject",
    messageRequired: "Please enter the message",
    deleteWarn: "This will remove the message",
    suppressionEffectue: "message successfully deleted",
    NewCategorie: "New Message",
    iscreatedSuccessfully: "successfully created",
    sentMessage: "Your message has been sent successfully",
    isupdatedSuccessfully: "Message update successfully completed!",
    created_at: "Created at",
    edit: "Edit message",
    AddCategorie: "New message",
    sendTo: "Send to ",
  },
  roles: {
    deleteWarn: "Be careful, this will remove the role",
    permissions: "Permissions",
    nom: "Role name",
    users: "Users",
    extraMenus: "Additional menus",
    InheritedfromRole: "Inherited from the role",
    addRole: "Add a role",
    name: "Role",
    NewRole: "New role",
    iscreatedSuccessfully: "created successfully!",
    isupdatedSuccessfully: "Role updated successfully",
    NameRequired: "Please enter the role",
    edit: "Edit the role",
    suppressionEffectue: "Role deleted successfully",
  },
  specie: {
    specie: "Specie",
    species: "Species",
    name: "Name",
    body: "Description",
    NameRequired: "Please enter the name of the specie",
    deleteWarn: "THis will delete the specie",
    suppressionEffectue: "Specie deleted successfully !",
    NewSpecie: "New Specie",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Specie update successfully completed!",
    created_at: "Created at",
    edit: "Edit the specie",
    AddSpecie: "New specie",
    selectSpecieTitle: "Select the specie",
    specieRequired: "Please select the specie",
  },
  province: {
    reference: "Reference",
    code: "Code",
    province: "Province",
    provinces: "Provinces",
    name: "Name",
    NameRequired: "Please enter the name of the province",
    deleteWarn: "THis will delete the province",
    suppressionEffectue: "Province deleted successfully !",
    NewProvince: "New Province",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Province update successfully completed!",
    created_at: "Created at",
    edit: "Edit the province",
    AddProvince: "New province",
    selectProvinceTitle: "Select the province",
    provinceRequired: "Please select the province",
  },
  department: {
    department: "Department",
    departments: "Departments",
    name: "Name",
    NameRequired: "Please enter the name of the department",
    deleteWarn: "THis will delete the department",
    suppressionEffectue: "Department deleted successfully !",
    NewDepartment: "New Department",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Department update successfully completed!",
    created_at: "Created at",
    edit: "Edit the department",
    AddDepartment: "New department",
    selectDepartmentTitle: "Select the department",
    departmentRequired: "Please select the department",
  },
  municipality: {
    municipality: "Municipality",
    municipalities: "Municipalities",
    name: "Name",
    NameRequired: "Please enter the name of the municipality",
    deleteWarn: "THis will delete the municipality",
    suppressionEffectue: "Municipality deleted successfully !",
    NewMunicipalitie: "New Municipality",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Municipality update successfully completed!",
    created_at: "Created at",
    edit: "Edit the municipality",
    AddMunicipalitie: "New municipality",
    selectMunicipalityTitle: "Select the municipality",
    municipalityRequired: "Please select the municipality",
  },
  village: {
    village: "Village",
    villages: "Villages",
    name: "Name",
    NameRequired: "Please enter the name of the village",
    deleteWarn: "THis will delete the village",
    suppressionEffectue: "Village deleted successfully !",
    NewVillage: "New Village",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Village update successfully completed!",
    created_at: "Created at",
    edit: "Edit the village",
    AddVillage: "New village",
    selectVillageTitle: "Select the village",
    villageRequired: "Please select the village",
  },
  registration: {
    registration: "Registration",
    registrations: "Registrations",
    ref: "Reference",
    maleNumber: "Males",
    femaleNumber: "Females",
    NameRequired: "Please enter the name of the registration",
    deleteWarn: "THis will delete the registration",
    status: "State",
    coordinates: "coordinates",
    suppressionEffectue: "Registration deleted successfully !",
    NewRegistration: "New Registration",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Registration update successfully completed!",
    created_at: "Created at",
    edit: "Edit the registration",
    AddRegistration: "New registration",
    selectRegistrationTitle: "Select the registration",
  },
  breed: {
    breed: "Breed",
    breeds: "Breeds",
    name: "Name",
    description: "Description",
    NameRequired: "Please enter the name of the breed",
    deleteWarn: "THis will delete the breed",
    suppressionEffectue: "Breed deleted successfully !",
    NewBreed: "New Breed",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Breed update successfully completed!",
    created_at: "Created at",
    edit: "Edit the breed",
    AddBreed: "New breed",
    selectBreedTitle: "Select the breed",
  },
  disease: {
    disease: "Disease",
    diseases: "Diseases",
    name: "Name",
    body: "Description",
    NameRequired: "Please enter the name of the disease",
    deleteWarn: "THis will delete the disease",
    suppressionEffectue: "Disease deleted successfully !",
    NewDisease: "New Disease",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Disease update successfully completed!",
    created_at: "Created at",
    edit: "Edit the disease",
    AddDisease: "New disease",
    selectDiseaseTitle: "Select the disease",
    selectDiseasesTitle: "Select the diseases",
    diseaseRequired: "Please select the disease",
    diseasesRequired: "Please select the diseases",
  },
  subscription: {
    subscription: "Member",
    subscriptions: "Members",
    organ: "Organ",
    story: "Story",
    age: "Age",
    height: "Height",
    weight: "Weight",
    gender: "Gender",
    zip_code: "Zip code",
    type: "Type",
    travel: "TRavel",
    travel_no: "Cannot travel",
    travel_yes: "Can travel",
    blod_type: "Blod type",
    OrganRequired: "Please select an organ",
    BodyRequired: "Tell us more about yourself! ",
    deleteWarn: "This will remove the subscription ",
    suppressionEffectue: "Subscription successfully deleted",
    NewSubscription: "New Subscription",
    iscreatedSuccessfully: "successfully created",
    isupdatedSuccessfully: "Successful subscription update!",
    created_at: "Created at",
    edit: "Edit the subscription",
    AddSubscription: "New subscription",
    UserRequired: "You must select a user",
    selectSubscriptionTitle: "Select a subscription",
    noSubscription: "Not subscribed",
    paired: "Paired",
  },
  report: {
    reported: "Reported",
    report: "Report",
    reports: "Reports",
    subject: "Subject",
    reasons: "Description",
    SubjectRequired: "Enter de subject of the report",
    BodyRequired: "Tel us more !",
    deleteWarn: "This wil delete thereport",
    suppressionEffectue: "Report successfully deleted",
    NewReport: "New Report",
    iscreatedSuccessfully: "created successfully",
    isupdatedSuccessfully: "Report successfully updated !",
    created_at: "Updated at",
    edit: "Edit the report",
    AddReport: "New report",
    UserRequired: "You must select a user",
    selectReportTitle: "Select a report",
    processing: "Psrocessing",
  },
  discussion: {
    discussion: "Discussion",
    discussions: "Discussions",
    sender: "Initiator",
    with: "With",
  },
  article: {
    articles: "Articles",
    title: "Title",
    content: "Content",
    TitleRequired: "Please enter the article title",
    contentRequired: "Write your article!",
    deleteWarn: "This will delete the article!",
    suppressionEffectue: "Article successfully deleted",
    NewArticle: "New Article",
    iscreatedSuccessfully: "successfully created",
    isupdatedSuccessfully: "Article update successfully completed!",
    created_at: "Created at",
    edit: "Edit article",
    addTitle: "Enter the title of the article",
    CategorieRequired: "You must select a category",
    selectCategorieTitle: "Select category",
    addTitleandImageMessage:
      "Please enter the article title and add the default image",
    addSummary: "Add summary",
    addSummaryMessage:
      "Add a small description that can serve as a summary for your article. Specify the importance that will be used to classify the articles",
    addCategory: "Select a category",
    addCategoryMessage:
      "Please select a category, and keep open or closed comments for this article",
    addTag: "Add tags ! When do you want to publish?",
    addTagMessage:
      "Here you can specify the time of publication, you can also add tags. select the tags to add or create new ones!",
    SummaryRequired: "You must enter a summary",
    CategoryRequired: "You must select a category",
    Addarticle: "New article",
    approuvePost: "Approve article",
    approuvePostMessage: "Are you sure you want to publish this article?",
    yesPublish: "Yes publish",
    postDetails: "Post details",
  },
  comment: {
    comment: "Comment",
    comments: "Comments",
    postTitle: "Article",
    deleteWarn: "This will delete the article",
    suppressionEffectue: "Article deleted successfully",
    created_at: "Created at",
    edit: "Edit comment",
  },
  categorie: {
    categorie: "Category",
    categories: "Categories",
    label: "Label",
    description: "Description",
    labelRequired: "Please enter the category label",
    descriptionRequired: "A little details please!",
    deleteWarn: "This will remove the category",
    suppressionEffectue: "category successfully deleted",
    NewCategorie: "New Category",
    iscreatedSuccessfully: "successfully created",
    isupdatedSuccessfully: "Category update successfully completed!",
    created_at: "Created at",
    edit: "Edit category",
    AddCategorie: "New category",
    CategorieRequired: "You must select a category",
    selectCategorieTitle: "Select a category",
    articleCount: "Articles",
  },
  tag: {
    tag: "Tag",
    tags: "Tags",
    label: "Label",
    description: "Description",
    labelRequired: "Please enter the tag label",
    deleteWarn: "This will remove the tag",
    suppressionEffectue: "Tag successfully deleted",
    NewTag: "New Tag",
    iscreatedSuccessfully: "successfully created",
    isupdatedSuccessfully: "Tag update successfully completed!",
    created_at: "Created at",
    edit: "Edit tag",
    AddTag: "New tag",
    selectTagTitle: "Add tags",
  },
};
